<template>
  <b-card>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="updates.slice().reverse()"
    >
      <template #cell(state)="data">
        <b-badge
          pill
          :variant="getVariant(data.item.state)"
        >
          <span>
            {{ $t(data.item.state) }}
          </span>
        </b-badge>
      </template>
      <template #cell(date)="data">
        {{ convertToDate(data.item.date) }}
      </template>
      <template #cell(processer)="data">
        <span style="text-transform: capitalize">
          {{ data.item.processer }}
        </span>
      </template>
      <template #cell(content)="data">
        <span
          v-for="(item, index) in data.item.content"
          :key="index"
          class="small"
        >
          <b-link
            v-if="item.includes('Order: ')"
            class="font-weight-bold"
            target="_blank"
            :href="`https://hoiwa.zendesk.com/agent/tickets/${item.substring(7)}`"
          >
            {{ onConvertCamelCase(item) }} <br>
          </b-link>
          <b-link
            v-if="item.includes('Ticket: ')"
            class="font-weight-bold"
            target="_blank"
            :href="`https://hoiwa.zendesk.com/agent/tickets/${item.substring(9)}`"
          >
            {{ onConvertCamelCase(item) }} <br>
          </b-link>
          <span v-else>
            {{ onConvertCamelCase(item) }} <br>
          </span>
        </span>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  BCard, BTable, BBadge, BLink,
} from 'bootstrap-vue'
import * as moment from 'moment'
import 'moment-timezone'
import { onConvertCamelCase } from '@hw-core/utils'

export default {
  components: {
    BCard, BTable, BBadge, BLink,
  },
  props: {
    updates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'state', label: this.$t('shifts_calendar.table_headers.state'), tdClass: 'width-15 table-custom-style text-center', thClass: 'table-header-custom-style',
        },
        {
          key: 'date', label: this.$t('shifts_calendar.table_headers.date'), tdClass: 'width-30 table-custom-style text-center', thClass: 'table-header-custom-style',
        },
        {
          key: 'processer', label: this.$t('shifts_calendar.table_headers.processer'), tdClass: 'width-15 table-custom-style text-center', thClass: 'table-header-custom-style',
        },
        {
          key: 'content', label: this.$t('shifts_calendar.table_headers.content'), tdClass: 'width-40 table-custom-style padding-left-15', thClass: 'table-header-custom-style',
        },
      ],
    }
  },
  methods: {
    // TODO: remove this after few months
    convertToDate(date) {
      // check if date is a date object
      let result = date
      if (typeof date.toDate !== 'undefined') {
        result = date.toDate()
      }
      if (date.seconds) {
        result = new Date(date.seconds * 1000 + date.nanoseconds / 1000000)
      }
      return moment(result).tz('Europe/Helsinki').format('DD.MM.YYYY HH:mm')
    },
    getVariant(state) {
      let result = ''
      switch (state) {
        case 'created':
          result = 'info'
          break
        case 'booked':
          result = 'warning'
          break
        case 'unverified':
          result = 'danger'
          break
        case 'cancelled':
          result = 'danger'
          break
        case 'verified':
          result = 'primary'
          break
        case 'updated':
          result = 'warning'
          break
        case 'confirmed':
          result = 'success'
          break
        default:
          result = 'secondary'
      }
      return result
    },
    onConvertCamelCase,
  },
}
</script>

<style>
.width-15 {
    width: 15%
}
.width-30 {
    width: 30%
}
.width-40 {
    width: 40%
}
.table-custom-style {
    padding: 0.72rem 0 !important;
}
.table-header-custom-style {
    padding: 0.72rem 0 !important;
    text-align: center;
}
.text-center {
    text-align: center;
}
.padding-left-15 {
    padding-left: 15px !important;
}
</style>
